import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavMenuService } from '../shared/services/nav-menu-service';
import { Router, RoutesRecognized, ActivatedRoute } from '@angular/router';
import { filter, startWith, takeUntil, pairwise } from 'rxjs/operators';
import { LandingPageService } from './landing-page.service'
import { ValidMachine } from '../shared/viewmodels/ISearchService';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-landing-page',
  providers: [LandingPageService],
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LandingPageComponent implements OnInit {

  machineObj: ValidMachine;
  machineId: string;
  stationId: string;
  machineLocation: number;

  constructor(private nav: NavMenuService, private router: Router, private route: ActivatedRoute, private service: LandingPageService) { }

  async ngOnInit() {
    var x = window.location.href;

    var id = this.route.snapshot.params.machineId;

    //For local machines....... comment out for remote.....

    
    localStorage.removeItem("machineId");
    localStorage.removeItem("machineLocation");

    //if (id != 'DEEDS-PC1') {
    //  localStorage.setItem("machineLocation", '1')
    //  localStorage.setItem("machineId", 'VAULT');
    //} else {
    //  localStorage.setItem("machineLocation", '2')
    //  localStorage.setItem("machineId", 'DEEDS-PC1');
    //}

    //.....................................................

    //For remote machines....... comment out for local.....

    if (id === 'resetToWeb') {
      //reset back to web user
      localStorage.removeItem('machineId');
      this.machineLocation = 0;
      localStorage.setItem("machineLocation", this.machineLocation.toString());

    } else if (id !== undefined) {
      localStorage.removeItem("machineId");
      localStorage.removeItem("machineLocation");
      await this.service.getValidMachine(id).toPromise()
         .then(data => {
          this.machineObj = data;
          this.machineId = data.validMachine;
          this.stationId = data.validStation;
          this.machineLocation = data.machineLocation;
          localStorage.setItem("machineId", this.machineId);
          localStorage.setItem("machineLocation", this.machineLocation.toString());
        });
      //this.service.getValidMachine(id).subscribe(
      //  (data) => {
      //    this.machineObj = data;
      //    this.machineId = data.validMachine;
      //    this.stationId = data.validStation;
      //    this.machineLocation = data.machineLocation;
      //    localStorage.setItem("machineId", this.machineId);
      //    localStorage.setItem("machineLocation", this.machineLocation.toString());
      //  });
    }
    else {
      this.machineId = localStorage.getItem("machineId");
      let i = localStorage.getItem("machineLocation")
      if (i !== undefined && i != null) {
        this.machineLocation = i == '1' ? 1 : i == '2' ? 2 : 0;
        localStorage.setItem("machineLocation", this.machineLocation.toString());
      } else {
        this.machineLocation = 0
        localStorage.setItem("machineLocation", '0');
      }
    }

    //GetParameters here????

    console.log('machine ' + this.machineLocation)
    //...................................................

    this.nav.show();
    this.router.events.pipe(
      filter(e => e instanceof RoutesRecognized),
      pairwise()
    ).subscribe((event: any[]) => {

      if (event[1].urlAfterRedirects.endsWith('/')) {
        this.nav.navItems.forEach(value => {
          if (value.isActive) {
            value.isActive = false;
          }
        });
      }
    });
  }

  linkClick(name) {
    console.log(`clicked ${name}`);

    this.nav.navItems.forEach(function (value) {
      console.log(value.name + value.isActive);
      if (value.isActive) {
        value.isActive = false;
        console.log('prev acive' + value.name);
      }
      if (value.name == name) {
        value.isActive = true;
        console.log('new active' + value.name + value.isActive);
      }

    }
    );
    if (name == 'RecordedLand') {
      this.router.navigate(['/rec-name-search']);
    }
    else if (name == 'registeredLand') {
      this.router.navigate(['/reg-name-search']);
    }
    else if (name == 'propertySearch') {
      this.router.navigate(['/propsearch']);
    }
    else if (name == 'RecordedLandPlans') {
      this.router.navigate(['/rec-plan-name-search']);
    }
    else if (name == 'RegisteredLandPlans') {
      this.router.navigate(['/reg-plan-address-search']);
    }
    else if (name == 'UnindexedRecords') {
      this.router.navigate(['/unindexed-doc-search']);
//      this.router.navigate(['/unindexed-record-search1/1640-1799']);
    }

    
  }

}
